import { useMemo, useState } from "react";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { Program, AnchorProvider, Idl } from "@coral-xyz/anchor";
import { PublicKey } from "@solana/web3.js";

// Import the IDL generated by `anchor build`
import idl from "../idl/catswap.json";

const PROGRAM_ID = import.meta.env.VITE_PROGRAM_ID || idl.metadata.address;

export function useAnchorProgram() {
  const { connection } = useConnection();
  const wallet = useWallet();
  const [initError, setInitError] = useState<string | null>(null);

  const provider = useMemo(() => {
    if (!wallet.publicKey || !wallet.signTransaction || !wallet.signAllTransactions) {
      return null;
    }
    return new AnchorProvider(connection, wallet as any, {
      commitment: "confirmed",
    });
  }, [connection, wallet]);

  const program = useMemo(() => {
    if (!provider) return null;
    try {
      return new Program(idl as unknown as Idl, new PublicKey(PROGRAM_ID), provider);
    } catch (e: any) {
      // Anchor 0.30.1 Program constructor can crash with _bn error
      // if the wallet/provider state isn't fully ready
      setInitError(e?.message ?? String(e));
      return null;
    }
  }, [provider]);

  return { program, provider, programId: PROGRAM_ID, initError };
}
